export default {
  title: {
    en: 'Vault marketplace',
    ru: 'Торговая площадка Vault',
    fr: 'Marché du coffre-fort',
    es: 'Mercado de Vault',
    pt: 'Mercado Vault',
    de: 'Tresormarktplatz',
    zh: 'Vault平台',
  },
  description: {
    en: `
      Stake {depositToken} into your favourite Vaults and earn {depositToken} staking rewards from their validators.
      Make your stake liquid with {mintToken}.
    `,
    ru: `
      Сделайте ставку {depositToken} в своих любимых хранилищах и зарабатывайте вознаграждения за ставку {depositToken} от их валидаторов.
      Сделайте свою ставку жидкой с помощью {mintToken}.
    `,
    fr: `
      Stakez {depositToken} dans vos coffres-forts préférés et gagnez des récompenses
      de staking {depositToken} de la part de leurs validateurs. Faites votre pieu liquide avec {mintToken}.
    `,
    es: `
      Apuesta {depositToken} en tus Bóvedas favoritas y gana recompensas de apuestas {depositToken} de sus validadores.
      Haz tu estaca líquida con {mintToken}.
    `,
    pt: `
      Faça staking de {depositToken} nos seus Vaults favoritos e ganhe recompensas de staking de {depositToken} dos seus validadores.
      Deixe a sua estaca líquida com {mintToken}.
    `,
    de: `
      Setzen Sie {depositToken} in Ihre Lieblings-Tresore ein und verdienen Sie {depositToken}-Einsatzbelohnungen von ihren Validatoren.
      Machen Sie Ihren Einsatz mit {mintToken} flüssig.
    `,
    zh: `
      将{depositToken}质押到您最喜爱的Vault中，并从其验证者处获得{depositToken}质押奖励。
      用{mintToken}让您的木桩变成液体。
    `,
  },
}
